// AUTO GENERATED
// DO NOT MODIFY
import { animation } from './animation';
import { color } from './color';
import { gradient } from './gradient';
import { shadow } from './shadow';
export const designTokens = {
  animation,
  color,
  gradient,
  shadow
};